var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFrontier = function SvgFrontier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#CC703C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3502 8L23.2615 8.23476L22.971 8.9853L22.778 9.46909C21.3121 13.0968 20.1721 14.8183 18.9598 14.8183C18.6535 14.8264 18.3488 14.7706 18.0652 14.6546C17.7816 14.5385 17.5253 14.3646 17.3127 14.1441L17.158 14.0038C16.773 13.6485 16.611 13.5609 16.2402 13.5609C16.0472 13.5609 15.7015 13.807 15.2647 14.3853C14.6796 15.214 14.182 16.1012 13.7801 17.0326L13.7308 17.1418H18.9308L18.2832 18.4879H13.428V24H12V8H23.3502ZM21.3268 9.34359H13.428V14.6751C14.3744 13.0338 15.2741 12.2099 16.2417 12.2099C16.5671 12.1995 16.8911 12.2568 17.1932 12.3781C17.4953 12.4994 17.7689 12.6821 17.9966 12.9147L18.1562 13.0594C18.5156 13.3911 18.654 13.4674 18.9612 13.4674C19.2991 13.4679 20.1977 12.0406 21.3268 9.34359Z",
    fill: "white"
  })));
};

export { SvgFrontier as ReactComponent };
export default __webpack_public_path__ + "8ed3e5507e69540935eda6414744ee35.svg";